import { render, staticRenderFns } from "./AssetDisposal.vue?vue&type=template&id=ecb34354&scoped=true"
import script from "./AssetDisposal.vue?vue&type=script&lang=js"
export * from "./AssetDisposal.vue?vue&type=script&lang=js"
import style0 from "./AssetDisposal.vue?vue&type=style&index=0&id=ecb34354&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecb34354",
  null
  
)

export default component.exports